import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import {
  BootstrapTooltip,
  context_styles
} from "../context_builder_dark_styles";
import "../context_dark.css";
import axios from "axios";
import { makeStyles } from '@mui/styles';
import { useSpring, animated } from '@react-spring/web';
import { useSelector, useDispatch } from "react-redux";
import { defaultTabActions, feedbackActions, analysisActions, projectInfoActions, imageAnalysisActions } from "../../store/store";
import { Projects } from "../context_components/projects";
import DefaultSearchMode from "./modes/defaultSearchMode";
import AuditSearchMode from "./modes/auditSearchMode";
import SessionAuditSearchMode from "./modes/sessionAuditSearchMode";

export default function Default(props) {
  const { projectInfo, projects } = useSelector(state => state.projectInfoStore);
  const searchEntity = useSelector(state => state.defaultTabStore.search_input);
  const config = projects.filter(r => (
    (r.country === projectInfo[0]) &&
    (r.env === projectInfo[1])
  ))[0];
  const {
    color
  } = useSelector(state => state.themeStore);
  const baseProject = projectInfo[2];

  const {
    currentSearchMode,
    searchModes,
    storeData,
    sessionAuditList,
    userList,
    storeList,
    audits,
    selectedAudit,
    selectedOption,
    selectedType
  } = useSelector(state => state.defaultTabStore);

  const dispatch = useDispatch();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7,
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        opacity: 0,
        y: -15 + "%"
      },
      to: {
        opacity: 1,
        y: 0 + "%"
      }
    })
  }, [])

  
  useEffect(() => { }, [storeData])

  let searchMode = "Date";
  if (currentSearchMode === "Date") {
    searchMode = <DefaultSearchMode />
  } else if (currentSearchMode === "Audit") {
    searchMode = <AuditSearchMode />
  } else if (currentSearchMode === "Session Audit") {
    searchMode = <SessionAuditSearchMode />
  }

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={10} sx={context_styles}>

        {/* Search Mode */}
        {searchMode}

        {/* project info/switcher */}
        <Projects />
      </Paper>
    </animated.div>
  )
}